import { useMaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CustomTable } from 'src/presentations/components/molecules/table/Table';
import { DeviationDto } from 'src/generated/services/TFinancialApi';
import { ITableDeviationDetailsDTO } from './types';

export const TableMain = styled(Box)({
  '.MuiTableCell-head:first-of-type': {
    width: '40px',
  },
});

const useDeviationDetailsColumns = (type: DeviationDto['type']): MRT_ColumnDef<ITableDeviationDetailsDTO>[] => {
  const columns = [
    {
      accessorKey: 'category',
      header: 'Deviation Category',
      enableEditing: false,
      accessorFn: (row) => <span className='capitalize'>{row?.category}</span>,
    },
  ];

  if (type === 'QUANTITY') {
    columns.push({
      accessorKey: 'excessQuantity',
      header: 'Excess Quantity',
      enableEditing: false,
      accessorFn: (row) => <span className='capitalize text-red-40 font-bold'>{row?.excessQuantity}</span>,
    });
  } else if (type === 'NEW_CHARGE') {
    columns.push({
      accessorKey: 'amountPerUnit',
      header: 'Deviation Amount per Unit',
      enableEditing: false,
      accessorFn: (row) => <span className='capitalize text-red-40 font-bold'>{row?.amountPerUnit}</span>,
    });
  } else {
    columns.push({
      accessorKey: 'amountPerUnit',
      header: 'Amount per Unit',
      enableEditing: false,
      accessorFn: (row) => <span className='capitalize text-red-40 font-bold'>{row?.amountPerUnit}</span>,
    });
  }

  columns.push({
    accessorKey: 'totalAmount',
    header: 'Total Net Deviation Amount',
    enableEditing: false,
    accessorFn: (row) => <span className='capitalize text-red-40 font-bold'>{row?.totalAmount}</span>,
  });

  return columns;
};

export interface ITableDeviationDetailsProps {
  data: ITableDeviationDetailsDTO[];
  type: DeviationDto['type'];
}

export const TableDeviationDetails = ({ data, type }: ITableDeviationDetailsProps) => {
  const columns = useDeviationDetailsColumns(type);

  const table = useMaterialReactTable({
    data,
    enableRowNumbers: false,
    enableSorting: false,
    enablePinning: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enablePagination: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableEditing: false,
    editDisplayMode: 'table',
    columns,
  });
  return <CustomTable table={table} />;
};
